export const messages = {
  en: {
    integralGiftDetailManage: {
      search: {
        title: 'Search Conditions',
        detailId: 'Record ID',
        userNameLike: 'User Name',
        tel: 'Phone Number'
      },
      list: {
        title: 'Gift Records'
      },
      table: {
        detailId: 'Record ID',
        acctName: 'Account Name',
        configName: 'Standard Name',
        ruleName: 'Rule Name',
        quantity: 'Points Quantity',
        userName: 'User Name',
        tel: 'Phone Number',
        createTime: 'Gift Time'
      },
      fetchError: 'Failed to fetch gift records'
    }
  },
  zh: {
    integralGiftDetailManage: {
      search: {
        title: '查询条件',
        detailId: '记录编号',
        userNameLike: '用户名称',
        tel: '手机号'
      },
      list: {
        title: '赠送记录'
      },
      table: {
        detailId: '记录编号',
        acctName: '账户名称',
        configName: '标准名称',
        ruleName: '规则名称',
        quantity: '积分数量',
        userName: '用户名称',
        tel: '手机号',
        createTime: '赠送时间'
      },
fetchError: '獲取贈送記錄失敗'
    }
  },
  'zh-TW': {
    integralGiftDetailManage: {
      search: {
        title: '查詢條件',
        detailId: '記錄編號',
        userNameLike: '用戶名稱',
        tel: '手機號'
      },
      list: {
        title: '贈送記錄'
      },
      table: {
        detailId: '記錄編號',
        acctName: '帳戶名稱',
        configName: '標準名稱',
        ruleName: '規則名稱',
        quantity: '積分數量',
        userName: '用戶名稱',
        tel: '手機號',
        createTime: '贈送時間'
      },
      fetchError: '獲取贈送記錄失敗'
    }
  }
}